module.exports = __webpack_public_path__ + "img/1587835619.540a5208.jpg";